export default __webpack_public_path__ + "static/media/banner3.82123b90.jpg";